export const reviewsElementId = 'reviews-snippet';
